import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import React, { forwardRef, useContext, useState, useMemo, useRef, useEffect, isValidElement } from 'react';
import classNames from 'classnames';
import { Image, VisuallyHidden } from '@andes/common';
import { getPatchedI18n, AndesContext, useId } from '@andes/context';
import useSrLabel from '@andes/common/build/hooks/useSrLabel';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { Tooltip as Tooltip$1 } from '@andes/tooltip';
import { Popper } from '@andes/popper';
import { ESCAPE } from '@andes/common/build/constants/keyboardCodes';
import startsWith from '@andes/common/build/utils/startsWith';
import { FocusScope } from '@react-aria/focus';
import { Pill } from '@andes/badge';
import { Thumbnail } from '@andes/thumbnail';
import includes from '@andes/common/build/utils/includes';
const fillNamespace = 'fill';
const namespace$1 = 'andes-progress-indicator-linear';
const segmentNamespace = "".concat(namespace$1, "__segment");
var module$2 = "@andes/tooltip";
var locale$2 = "en-US";
var translations$2 = {
  "andes-tooltip\u0004cerrar": [null, "Close"]
};
var enTranslations = {
  module: module$2,
  locale: locale$2,
  translations: translations$2
};
var module$1 = "@andes/tooltip";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-tooltip\u0004cerrar": [null, "Cerrar"]
};
var esTranslations = {
  module: module$1,
  locale: locale$1,
  translations: translations$1
};
var module = "@andes/tooltip";
var locale = "pt-BR";
var translations = {
  "andes-tooltip\u0004cerrar": [null, "Fechar"]
};
var ptTranslations = {
  module: module,
  locale: locale,
  translations: translations
};
const namespace = 'andes-tooltip';
const BOTTOM = 'bottom';
const LEFT = 'left';
const RIGHT = 'right';
const TOP = 'top';
const BOTTOM_END = 'bottom-end';
const BOTTOM_START = 'bottom-start';
const LEFT_START = 'left-start';
const RIGHT_START = 'right-start';
const TOP_END = 'top-end';
const TOP_START = 'top-start';
var _Pill, _Pill2;
const getBadge = thumbnail => {
  if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.badge) === 'pill') return /*#__PURE__*/_jsx(Pill, {}, void 0, thumbnail.pillContent);
  if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.badge) === 'notification') return _Pill || (_Pill = /*#__PURE__*/_jsx(Pill, {
    contentType: "icon"
  }));
  if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.badge) === 'pill-icon') return _Pill2 || (_Pill2 = /*#__PURE__*/_jsx(Pill, {
    contentType: "icon"
  }));
};
const getThumbnailType = (thumbnail, image, icons) => {
  const commonProps = {
    badge: getBadge(thumbnail),
    className: "".concat(namespace, "__image")
  };
  if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.type) === 'image') {
    return /*#__PURE__*/React.createElement(Thumbnail, _extends({}, commonProps, {
      srLabel: image === null || image === void 0 ? void 0 : image.title
    }), /*#__PURE__*/React.createElement(Image, image));
  }
  if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.type) === 'icons' && icons) {
    return /*#__PURE__*/React.createElement(Thumbnail, _extends({
      hierarchy: thumbnail.hierarchy,
      disabled: thumbnail.disabled
    }, commonProps), icons);
  }
};
const TooltipContent = _ref => {
  let {
    actions,
    closable = false,
    closeIconLabel,
    closeTooltip,
    content,
    focusScope = false,
    icons,
    id,
    image,
    onMouseEnter,
    onMouseLeave,
    open,
    placement = TOP,
    thumbnail,
    title
  } = _ref;
  const i18n = getPatchedI18n(AndesContext, enTranslations, esTranslations, ptTranslations);
  const tooltipContentClassNames = classNames("".concat(namespace, "-data"), {
    ["".concat(namespace, "-data-image")]: image || icons
  });
  const arrowClassNames = classNames("".concat(namespace, "-data__arrow"), {
    ["".concat(namespace, "-data__arrow--").concat(placement)]: placement
  });
  const onCloseButtonClick = e => {
    e.preventDefault();
    e.stopPropagation();
    closeTooltip(e);
  };
  return /*#__PURE__*/_jsx("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, void 0, /*#__PURE__*/_jsx(FocusScope, {
    contain: open && focusScope,
    restoreFocus: true,
    autoFocus: true
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: tooltipContentClassNames,
    tabIndex: -1
  }, void 0, focusScope && /*#__PURE__*/_jsx("div", {
    tabIndex: 0,
    className: "".concat(namespace, "__focus-retainer")
  }), closable && /*#__PURE__*/
  _jsx("button", {
    className: "".concat(namespace, "-button-close"),
    onClick: onCloseButtonClick,
    "aria-label": closeIconLabel || i18n.pgettext(namespace, 'close'),
    type: "button"
  }), thumbnail && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__image-container")
  }, void 0, getThumbnailType(thumbnail, image, icons)), /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__content")
  }, void 0, title && /*#__PURE__*/_jsx("span", {
    id: id ? "".concat(id, "-title") : undefined,
    className: "".concat(namespace, "__title")
  }, void 0, title), content && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__text")
  }, void 0, content), actions && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__actions")
  }, void 0, actions)), /*#__PURE__*/_jsx("div", {
    className: arrowClassNames,
    "data-popper-arrow": true
  }))));
};
var TooltipContent$1 = TooltipContent;
var offsetDefaultValues = {
  top: [0, 16],
  topLeft: [-10, 16],
  topRight: [10, 16],
  bottom: [0, 16],
  bottomLeft: [-10, 16],
  bottomRight: [10, 16],
  left: [0, 16],
  leftTop: [-10, 16],
  right: [0, 16],
  rightTop: [-10, 16]
};
const CLICK = 'click';
const HOVER = 'hover';
const LIGHT = 'light';
const placementMapping = {
  topLeft: TOP_START,
  top: TOP,
  topRight: TOP_END,
  bottomLeft: BOTTOM_START,
  bottom: BOTTOM,
  bottomRight: BOTTOM_END,
  leftTop: LEFT_START,
  left: LEFT,
  rightTop: RIGHT_START,
  right: RIGHT
};
const Tooltip = /*#__PURE__*/function () {
  const Tooltip = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      actions,
      afterVisibleChange: _willdeprecate$afterVisibleChange,
      autoHideDelay,
      children,
      className,
      closable = false,
      closeIconLabel,
      content,
      defaultOpen,
      disableClickOutside = false,
      focusScope = true,
      icons,
      id,
      image,
      mouseEnterDelay = 0,
      mouseLeaveDelay = 0.1,
      offsetX = 0,
      offsetY = 0,
      onClickOutside: _willdeprecate$onClickOutside,
      onClose,
      onCloseTooltip: _willdeprecate$onCloseTooltip,
      onOpen,
      onVisibleChange: _willdeprecate$onVisibleChange,
      open,
      showCloseButton: _willdeprecate$showCloseButton,
      side = TOP,
      thumbnail,
      title,
      trigger = HOVER,
      type = LIGHT,
      visible: _willdeprecate$visible
    } = _ref;
    const componentId = useId(id);
    const srLabelVisibility = useSrLabel();
    const {
      device
    } = useContext(AndesContext);
    const isMobile = device === null || device === void 0 ? void 0 : device.mobile;
    const classes = classNames(className, namespace, {
      ["".concat(namespace, "--").concat(type)]: type
    });
    const isTooltipClosable = _willdeprecate$showCloseButton || closable;
    const clickTrigger = trigger === CLICK;
    const hoverTrigger = trigger === HOVER;
    const interactive = !!actions || clickTrigger || isTooltipClosable;
    const role = interactive ? 'dialog' : 'tooltip';
    const isDialog = role === 'dialog';
    const [visibleState, setVisibleState] = useState(false);
    const [placement, setPlacement] = useState('');
    const isControlled = useMemo(() => typeof open !== 'undefined', []);
    const autoHideTimeout = useRef();
    const openTimeout = useRef();
    const closeTimeout = useRef();
    const hoverCloseTimeout = useRef();
    const firstRender = useRef(true);
    const triggerRef = useRef();
    const setTriggerReference = current => {
      triggerRef.current = current;
    };
    const openTooltip = () => {
      if (typeof onOpen === 'function') onOpen();
      if (!isControlled) {
        openTimeout.current = setTimeout(() => setVisibleState(true), mouseEnterDelay * 1000);
        clearTimeout(closeTimeout.current);
      }
    };
    const closeTooltip = event => {
      if (typeof onClose === 'function') onClose(event);
      if (!isControlled) {
        closeTimeout.current = setTimeout(() => setVisibleState(false), mouseLeaveDelay * 1000);
        clearTimeout(openTimeout.current);
      }
    };
    const visibleChange = isVisible => {
      if (isVisible && autoHideDelay) autoHideTimeout.current = setTimeout(() => setVisibleState(false), autoHideDelay);
      if (!isVisible) clearTimeout(autoHideTimeout.current);
      if (typeof _willdeprecate$onCloseTooltip === 'function' && !isVisible) _willdeprecate$onCloseTooltip();
      if (typeof _willdeprecate$onVisibleChange === 'function') _willdeprecate$onVisibleChange(isVisible);
      if (typeof _willdeprecate$afterVisibleChange === 'function') _willdeprecate$afterVisibleChange(isVisible);
    };
    useEffect(() => {
      if (!firstRender.current) {
        visibleChange(visibleState);
      } else {
        firstRender.current = false;
      }
    }, [visibleState]);
    useEffect(() => {
      if (typeof _willdeprecate$visible !== 'undefined') {
        setVisibleState(_willdeprecate$visible);
      }
    }, [_willdeprecate$visible]);
    useEffect(() => {
      if (defaultOpen) {
        openTimeout.current = setTimeout(() => setVisibleState(true), mouseEnterDelay * 1000);
        clearTimeout(closeTimeout.current);
      }
    }, []);
    useEffect(() => {
      if (isControlled) {
        if (open) {
          openTimeout.current = setTimeout(() => setVisibleState(true), mouseEnterDelay * 1000);
          clearTimeout(closeTimeout.current);
        } else {
          closeTimeout.current = setTimeout(() => setVisibleState(false), mouseLeaveDelay * 1000);
          clearTimeout(openTimeout.current);
        }
      }
    }, [open]);
    const clickOutside = (_, event) => {
      if (typeof _willdeprecate$onClickOutside === 'function') {
        _willdeprecate$onClickOutside(event);
      }
      if (!disableClickOutside) {
        closeTooltip(event);
      }
    };
    const closeAfterHoverTimer = () => {
      hoverCloseTimeout.current = setTimeout(event => closeTooltip(event), 300);
      if (!visibleState) {
        clearTimeout(hoverCloseTimeout.current);
        clearTimeout(openTimeout.current);
      }
    };
    const onMouseEnterChild = () => {
      clearTimeout(hoverCloseTimeout.current);
      clearTimeout(closeTimeout.current);
    };
    const onMouseLeave = interactive ? closeAfterHoverTimer : closeTooltip;
    const onClick = visibleState ? closeTooltip : openTooltip;
    const onKeyDown = event => {
      if (event.code === ESCAPE) {
        closeTooltip(event);
      }
    };
    const getAdaptedOffsetValues = () => {
      if (startsWith(side, BOTTOM)) return [offsetX, offsetY];
      if (startsWith(side, LEFT)) return [offsetY, -offsetX];
      if (startsWith(side, RIGHT)) return [offsetY, offsetX];
      return [offsetX, -offsetY];
    };
    const offset = offsetX !== 0 && offsetY !== 0 ? getAdaptedOffsetValues() : offsetDefaultValues["".concat(side)];
    const onTippyMount = instance => {
      var _instance$popperInsta;
      instance.popper.setAttribute('role', role);
      setPlacement((_instance$popperInsta = instance.popperInstance) === null || _instance$popperInsta === void 0 ? void 0 : _instance$popperInsta.state.placement);
      if (isDialog) {
        instance.reference.removeAttribute('aria-expanded');
        if (clickTrigger || !focusScope) {
          instance.popper.setAttribute('aria-modal', focusScope.toString());
          instance.popper.focus();
          const interactiveElements = [].slice.call(instance.popper.querySelectorAll(".".concat(namespace, "__focus-retainer")));
          if (interactiveElements.length) {
            interactiveElements[0].focus();
          }
        }
        instance.popper.setAttribute('aria-labelledby', "".concat(componentId, "-title"));
      }
      instance.reference.removeAttribute('aria-describedby');
    };
    const onTippyHide = (instance, _ref2) => {
      let {
        preventFocus
      } = _ref2;
      if (isDialog) {
        instance.reference.removeAttribute('aria-expanded');
        instance.popper.removeAttribute('aria-modal');
        instance.popper.removeAttribute('aria-label');
        instance.popper.removeAttribute('aria-labelledby');
        if (clickTrigger && instance.reference.children[0] instanceof HTMLElement && !preventFocus) {
          instance.reference.children[0].focus();
        }
      }
      instance.popper.removeAttribute('role');
    };
    const renderChildren = () => React.Children.map(children, child => {
      var _child$type, _child$type2, _child$props, _child$props2;
      const triggerProps = {
        'aria-describedby': !interactive ? "informative-".concat(componentId) : undefined,
        'aria-expanded': clickTrigger ? visibleState : undefined,
        'aria-haspopup': clickTrigger || undefined
      };
      const hasInputProps = includes(['AmountField', 'Checkbox', 'FileUploader', 'InlineEdit', 'Password', 'SearchBox', 'SearchboxSplit', 'SplitTextfield', 'Switch', 'TextField'], (child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) || (child === null || child === void 0 || (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.name));
      return child && /*#__PURE__*/isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, _objectSpread({}, hasInputProps ? {
        inputProps: _objectSpread(_objectSpread({}, typeof (child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.inputProps) === 'object' && ((child === null || child === void 0 || (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.inputProps) || {})), triggerProps)
      } : triggerProps)) : null;
    });
    const getContent = () => /*#__PURE__*/_jsx(TooltipContent$1, {
      title: title,
      content: content,
      thumbnail: thumbnail,
      image: image,
      icons: icons,
      closable: isTooltipClosable || clickTrigger,
      actions: actions,
      placement: placement || placementMapping["".concat(side)],
      closeTooltip: closeTooltip,
      onMouseEnter: hoverTrigger ? onMouseEnterChild : undefined,
      onMouseLeave: hoverTrigger ? closeTooltip : undefined,
      focusScope: interactive && clickTrigger && focusScope,
      open: visibleState,
      id: componentId,
      closeIconLabel: closeIconLabel
    });
    const flipModifier = isMobile ? {
      options: {
        fallbackPlacements: placement ? [placement] : [TOP, BOTTOM]
      }
    } : {
      enabled: false
    };
    return /*#__PURE__*/React.createElement("div", {
      ref: ref
    }, /*#__PURE__*/_jsx(Popper, {
      placement: placement || placementMapping["".concat(side)],
      className: classes,
      interactive: interactive,
      interactiveDebounce: 75,
      offset: offset,
      onClickOutside: clickOutside,
      visible: visibleState,
      popperOptions: {
        modifiers: [_objectSpread({
          name: 'flip'
        }, flipModifier)]
      },
      role: role,
      plugins: [{
        name: 'hideOnEsc',
        defaultValue: true,
        fn(_ref3) {
          let {
            popper
          } = _ref3;
          function localOnKeyDown(event) {
            onKeyDown(event);
          }
          return {
            onShow() {
              popper.addEventListener('keydown', localOnKeyDown);
            },
            onHide() {
              popper.removeEventListener('keydown', localOnKeyDown);
            }
          };
        }
      }, {
        name: 'hideOnPopperBlur',
        defaultValue: hoverTrigger && interactive,
        fn(instance) {
          return {
            onMount() {
              instance.popper.addEventListener('focusout', event => {
                if (instance.props.hideOnPopperBlur && (event.relatedTarget && !instance.popper.contains(event.relatedTarget) || !event.relatedTarget)) {
                  closeTooltip(event);
                }
              });
            }
          };
        }
      }],
      content: getContent(),
      onMount: onTippyMount,
      onHidden: onTippyHide,
      reference: triggerRef.current,
      aria: {
        expanded: undefined
      },
      focusScope: focusScope
    }), /*#__PURE__*/React.createElement("div", {
      ref: setTriggerReference,
      className: "".concat(namespace, "__trigger"),
      onMouseEnter: hoverTrigger ? openTooltip : undefined,
      onMouseLeave: hoverTrigger ? onMouseLeave : undefined,
      onFocus: hoverTrigger ? openTooltip : undefined,
      onBlur: hoverTrigger && !interactive ? onMouseLeave : undefined,
      onClick: clickTrigger || isMobile && hoverTrigger ? onClick : undefined,
      onKeyDown: clickTrigger ? onKeyDown : undefined
    }, typeof children === 'string' ? children : renderChildren()), !interactive && /*#__PURE__*/_jsx(VisuallyHidden, {
      id: "informative-".concat(componentId),
      "aria-hidden": true
    }, void 0, srLabelVisibility && /*#__PURE__*/React.createElement(React.Fragment, null, title, " ", content)));
  });
  Tooltip.displayName = 'Tooltip';
  return Tooltip;
}();
const ComparisonContent = _ref => {
  let {
    id,
    size = 'small',
    srLabel,
    value = 0,
    tooltipConfig,
    label
  } = _ref;
  const comparisonNamespace = "".concat(namespace$1, "--comparison");
  const comparisonClasses = classNames(comparisonNamespace, {
    ["".concat(comparisonNamespace, "--").concat(size)]: size
  });
  const styleComparison = {
    left: "".concat(value, "%")
  };
  const indicator = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("span", {
    className: "".concat(comparisonClasses, "-upper-row")
  }), /*#__PURE__*/_jsx("span", {
    className: "".concat(comparisonClasses, "-lower-row")
  }));
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$1, "--comparison"),
    style: styleComparison
  }, void 0, tooltipConfig ? /*#__PURE__*/React.createElement(Tooltip$1, _extends({}, tooltipConfig, {
    className: "".concat(comparisonClasses, "-tooltip")
  }), /*#__PURE__*/_jsx("button", {
    className: "".concat(comparisonClasses, "-container"),
    "aria-labelledby": "".concat(id, "-label"),
    "aria-label": srLabel,
    type: "button"
  }, void 0, indicator())) : /*#__PURE__*/_jsx("div", {
    className: "".concat(comparisonClasses, "-notooltip-container")
  }, void 0, srLabel && /*#__PURE__*/_jsx(VisuallyHidden, {}, void 0, srLabel), indicator()), label && /*#__PURE__*/_jsx("span", {
    className: "".concat(comparisonClasses, "-value"),
    id: "".concat(id, "-label")
  }, void 0, label));
};
const tooltipComparisonPropTypes = _objectSpread({}, Tooltip.propTypes);
delete tooltipComparisonPropTypes.children;
var ComparisonContent$1 = ComparisonContent;
const ProgressIndicatorLinear = /*#__PURE__*/function () {
  const ProgressIndicatorLinear = /*#__PURE__*/forwardRef((props, ref) => {
    const {
      id,
      className,
      size = 'small',
      color,
      value = 0,
      highlight = false,
      inverted = false,
      segments,
      srLabel,
      srValueText,
      srAnnouncement,
      'aria-label': ariaLabel,
      notificationsLabel,
      comparison
    } = props;
    const isSegmentedProgress = !!segments;
    const componentId = useId(id);
    const srLabelVisibility = useSrLabel();
    const labelTimeoutRef = useRef();
    const computedNotificationLabel = srAnnouncement || notificationsLabel;
    const [notificationsLabelState, setNotificationsLabelState] = useState(computedNotificationLabel);
    useEffect(() => {
      setNotificationsLabelState(computedNotificationLabel);
      labelTimeoutRef.current = setTimeout(() => setNotificationsLabelState(''), 30);
    }, [computedNotificationLabel]);
    useEffect(() => () => clearTimeout(labelTimeoutRef.current), []);
    const style = isSegmentedProgress ? {} : {
      width: "".concat(value, "%"),
      backgroundColor: color
    };
    const classVariables = {
      ["".concat(namespace$1, "--").concat(size)]: size,
      ["".concat(namespace$1, "--segmented")]: isSegmentedProgress
    };
    const classes = classNames(namespace$1, className, classVariables);
    const fillClasses = classNames(fillNamespace, isSegmentedProgress ? {
      ["".concat(fillNamespace, "--segmented")]: isSegmentedProgress
    } : {
      ["".concat(fillNamespace, "--empty")]: value === 0,
      ["".concat(fillNamespace, "--highlighted")]: highlight,
      ["".concat(fillNamespace, "--inverted")]: inverted
    });
    const SegmentedProgress = () => {
      const progress = [];
      for (let i = 0; i < (segments || 0); i += 1) {
        const isActive = i < value;
        const segmentedProgressClass = classNames(segmentNamespace, {
          ["".concat(segmentNamespace, "--active")]: isActive
        });
        progress.push(/*#__PURE__*/_jsx("div", {
          className: segmentedProgressClass,
          style: {
            backgroundColor: isActive ? color : undefined
          }
        }, i));
      }
      return progress;
    };
    return /*#__PURE__*/React.createElement("div", {
      className: classes,
      ref: ref
    }, /*#__PURE__*/_jsx(VisuallyHidden, {
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true"
    }, void 0, srLabelVisibility && notificationsLabelState), /*#__PURE__*/_jsx("div", {
      id: componentId,
      style: style,
      className: fillClasses,
      role: "progressbar",
      "aria-valuenow": value,
      "aria-valuemin": 0,
      "aria-valuemax": segments || 100,
      "aria-valuetext": isSegmentedProgress ? srValueText : undefined,
      "aria-label": srLabel || ariaLabel
    }, void 0, isSegmentedProgress && SegmentedProgress()), comparison && /*#__PURE__*/React.createElement(ComparisonContent$1, _extends({
      size: size,
      id: "".concat(componentId, "-comparison")
    }, comparison)));
  });
  ProgressIndicatorLinear.displayName = 'ProgressIndicatorLinear';
  return ProgressIndicatorLinear;
}();
var ProgressIndicatorLinear$1 = ProgressIndicatorLinear;
export { ProgressIndicatorLinear$1 as ProgressIndicatorLinear, ProgressIndicatorLinear$1 as default };
